const render = {
  listLabel1: 'Common Area',
  listLabel2: 'Tables',
  listLabel3: 'User Area',
  listLabel4: 'Parameters',
  listLabel5: 'System'
}

export default render;
